export default __webpack_public_path__ + "static/media/redTriangle.caa682c0.svg";